define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var DesignCenterActions;
    (function (DesignCenterActions) {
        DesignCenterActions.ns = 'DesignCenter';
        var create;
        (function (create) {
            var ns = DesignCenterActions.ns + ".create";
            var prefix = ns + ".photo";
            create.photo = {
                start: prefix + ".start",
                add: prefix + ".add",
                use: prefix + ".use",
                discard: prefix + ".discard",
                offer: prefix + ".offer"
            };
        })(create = DesignCenterActions.create || (DesignCenterActions.create = {}));
        ;
        var prefix = DesignCenterActions.ns + ".edit";
        var DesignAction;
        (function (DesignAction) {
            DesignAction[DesignAction["open"] = 0] = "open";
            DesignAction[DesignAction["close"] = 1] = "close";
            DesignAction[DesignAction["select"] = 2] = "select";
            DesignAction[DesignAction["drag"] = 3] = "drag";
            DesignAction[DesignAction["width"] = 4] = "width";
            DesignAction[DesignAction["height"] = 5] = "height";
        })(DesignAction = DesignCenterActions.DesignAction || (DesignCenterActions.DesignAction = {}));
        var makeDesignActionNames = function (prefix) {
            var keys = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                keys[_i - 1] = arguments[_i];
            }
            return keys.reduce(function (cur, key) {
                var keyName = DesignAction[key];
                cur[keyName] = prefix + "." + DesignAction[key];
                return cur;
            }, {});
        };
        DesignCenterActions.edit = {
            save: prefix + ".save",
            clone: prefix + ".clone",
            back: prefix + ".back",
            "delete": prefix + ".delete",
            deleteConfirm: prefix + ".deleteConfirm",
            summary: {
                show: prefix + ".summary.show",
                hide: prefix + ".summary.hide",
                addToCart: prefix + ".summary.addToCart"
            },
            prev: prefix + ".prev",
            next: prefix + ".next",
            position: makeDesignActionNames(prefix + ".position", DesignAction.open, DesignAction.close, DesignAction.drag),
            style: makeDesignActionNames(prefix + ".style", DesignAction.open, DesignAction.close, DesignAction.select),
            fabric: makeDesignActionNames(prefix + ".fabric", DesignAction.open, DesignAction.close, DesignAction.select),
            fringe: makeDesignActionNames(prefix + ".fringe", DesignAction.open, DesignAction.close, DesignAction.select),
            size: makeDesignActionNames(prefix + ".size", DesignAction.open, DesignAction.close, DesignAction.width, DesignAction.height),
            color: makeDesignActionNames(prefix + ".color", DesignAction.open, DesignAction.close, DesignAction.select)
        };
    })(DesignCenterActions = exports.DesignCenterActions || (exports.DesignCenterActions = {}));
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/designActions.js
// module id = 38
// module chunks = 0